import { A, useLocation } from "@solidjs/router";
import { createMemo, createSignal, Show } from "solid-js";
import { useUserContext } from "./UserContext";
import { AdminMenu } from "./Admin";
import { NavDropdown } from "./Components";
import { SocketStatus } from "./socket";

export default function Layout(props: any) {
  const [userStore] = useUserContext() as any;
  const location = useLocation();
  
  // Check if we're on a public page or student quiz (no navigation needed)
  const isPublicPage = createMemo(() => location.pathname.startsWith('/public/'));
  const isStudentQuiz = createMemo(() => location.pathname.startsWith('/q/'));
  const hideNavbar = createMemo(() => isPublicPage() || isStudentQuiz());
  
  const [collapsed, setCollapsed] = createSignal(true);

  return (
    <div class={hideNavbar() ? '' : 'container'}>
      <Show when={!hideNavbar()}>
        <nav class="navbar navbar-expand-lg sticky-top navbar-light bg-light">
          <div class="container-fluid">
            <A class="navbar-brand" href="/">Live Quiz</A>
            <button onClick={() => setCollapsed(!collapsed())} class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div classList={{
              "collapse": true,
              "navbar-collapse": true,
              "show": !collapsed()
            }} id="navbarNavDropdown">
              <ul class="navbar-nav">
                <li class="nav-item">
                  <A class="nav-link" end={true} href="/">Home</A>
                </li>
                <Show when={userStore.role === 'admin'}>
                  <li class="nav-item"><A class="nav-link" href="/manage-quizzes">Manage Quizzes</A></li>
                </Show>
                <NavDropdown label={userStore.username || 'Non connecté'}>
                  <li><A class="nav-link" href="/user-settings">Settings</A></li>
                </NavDropdown>
                <Show when={userStore.role === 'admin'}>
                  <AdminMenu />
                </Show>
              </ul>
            </div>
          </div>
        </nav>
      </Show>

      <div class={hideNavbar() ? '' : 'py-3'}>
        {props.children}
      </div>

      <Show when={!hideNavbar()}>
        <SocketStatus />
      </Show>
    </div>
  );
}
